import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsMaintenanceStrategy, PmsMaintenanceStrategy } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsMaintenanceStrategy>
    useData={usePmsMaintenanceStrategy}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
